class adherenceSingleVideo {
    constructor() {
        this.btnShowTranscript = document.querySelectorAll("[data-show-transcript-video]");
        this.init();
    }

    init() {
        const $this = this;
        if ($this.btnShowTranscript) {
            $this.btnShowTranscript.forEach(node => {
                node.addEventListener("click", e => {
                    e.preventDefault();
                    const transcript = node.nextElementSibling;
                    const playerWrap = node.closest(".video-player-wrap");
                    node.classList.toggle("js-expanded");

                    node.querySelector(".fa-plus").classList.toggle("hidden");
                    node.querySelector(".fa-minus").classList.toggle("hidden");

                    playerWrap.classList.toggle("js-expanded");
                    transcript.classList.toggle("hidden");
                });
            });
        }
    }
}

export default adherenceSingleVideo;
